import { jsx as _jsx, jsxs as _jsxs } from "preact/jsx-runtime";
import { useState, useEffect } from 'preact/hooks';
import { CampaignInfoSection } from '../CampaignInfoSection';
import { CampaignModal } from '../CampaignModal';
import { useAIChatContextUpdater } from '@/hooks';
import { ChatLocations, ChatEntityTypes, ChatViewModes } from '@/constants/aiChat';
import { useUserProfile } from '@/hooks/useUserProfile';
export function CampaignDetailsTab({ campaign, clientCompanyId, selectedWorkspaceId, onCampaignUpdated }) {
    const { getWorkspaceCapabilities } = useUserProfile();
    const { canEdit } = getWorkspaceCapabilities(clientCompanyId, selectedWorkspaceId);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const { updateContext } = useAIChatContextUpdater();
    // Update AI context when viewing campaign details
    useEffect(() => {
        updateContext({
            workspaceId: selectedWorkspaceId,
            campaignId: campaign.Id,
            location: ChatLocations.CampaignDetails,
            entityType: ChatEntityTypes.Campaign,
            entityId: campaign.Id,
            viewMode: ChatViewModes.View,
            availableFields: [
                {
                    name: 'campaignName',
                    displayName: 'Campaign Name',
                    fieldType: 'text',
                    isEditable: false,
                    isFocused: false,
                },
                {
                    name: 'targetAudience',
                    displayName: 'Target Audience',
                    fieldType: 'textarea',
                    isEditable: false,
                    isFocused: false,
                },
                {
                    name: 'campaignDescription',
                    displayName: 'Description',
                    fieldType: 'textarea',
                    isEditable: false,
                    isFocused: false,
                },
                {
                    name: 'status',
                    displayName: 'Status',
                    fieldType: 'text',
                    isEditable: false,
                    isFocused: false,
                },
            ],
            availableActions: ['Edit Campaign'],
        });
    }, [campaign, selectedWorkspaceId, updateContext]);
    const handleCampaignSaved = (updatedCampaign) => {
        onCampaignUpdated(updatedCampaign);
        setIsEditModalOpen(false);
    };
    return (_jsxs("div", { children: [_jsx(CampaignInfoSection, { campaign: campaign, onEditCampaign: canEdit ? () => setIsEditModalOpen(true) : undefined }), isEditModalOpen && (_jsx(CampaignModal, { isOpen: isEditModalOpen, onClose: () => {
                    setIsEditModalOpen(false);
                    // Reset AI context back to View mode
                    updateContext({
                        workspaceId: selectedWorkspaceId,
                        campaignId: campaign.Id,
                        location: ChatLocations.CampaignDetails,
                        entityType: ChatEntityTypes.Campaign,
                        entityId: campaign.Id,
                        viewMode: ChatViewModes.View,
                        availableFields: [
                            {
                                name: 'campaignName',
                                displayName: 'Campaign Name',
                                fieldType: 'text',
                                isEditable: false,
                                isFocused: false,
                            },
                            {
                                name: 'targetAudience',
                                displayName: 'Target Audience',
                                fieldType: 'textarea',
                                isEditable: false,
                                isFocused: false,
                            },
                            {
                                name: 'campaignDescription',
                                displayName: 'Description',
                                fieldType: 'textarea',
                                isEditable: false,
                                isFocused: false,
                            },
                            {
                                name: 'status',
                                displayName: 'Status',
                                fieldType: 'text',
                                isEditable: false,
                                isFocused: false,
                            },
                        ],
                        availableActions: ['Edit Campaign'],
                    });
                }, selectedWorkspaceId: selectedWorkspaceId, onCampaignSaved: handleCampaignSaved, editCampaign: campaign, clientCompanyId: clientCompanyId }))] }));
}
